export default __webpack_public_path__ + "images/2O.27b6cba.png";